module.exports = __webpack_public_path__ + "img/98.4a14cf18.webp";